import { Box, Typography } from "@mui/material";
import {
  Groups,
  AccountBalance,
  ReceiptLong,
  Engineering,
  AdminPanelSettings,
  People,
  Security,
  Work,
  Business,
  Settings,
  Assessment,
  Gavel,
} from "@mui/icons-material";

const AVAILABLE_ICONS = [
  { key: "groups", label: "Grupos", Icon: Groups },
  { key: "account_balance", label: "Banco", Icon: AccountBalance },
  { key: "receipt_long", label: "Fiscal", Icon: ReceiptLong },
  { key: "gavel", label: "Jurídico", Icon: Gavel },
  { key: "admin_panel_settings", label: "Admin", Icon: AdminPanelSettings },
  { key: "engineering", label: "Operações", Icon: Engineering },
  { key: "assessment", label: "Gráfico", Icon: Assessment },
  { key: "security", label: "Escudo", Icon: Security },
  { key: "settings", label: "Config.", Icon: Settings },
  { key: "people", label: "Pessoas", Icon: People },
  { key: "business", label: "Prédio", Icon: Business },
  { key: "work", label: "Computador", Icon: Work },
];

const IconSelector = ({ value = "groups", onChange }) => {
  return (
    <Box>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
        {AVAILABLE_ICONS.map(({ key, label, Icon }) => (
          <Box
            key={key}
            onClick={() => onChange(key)}
            sx={{
              width: 44,
              height: 44,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: value === key ? "2px solid #1a73e8" : "2px solid #e8eaed",
              borderRadius: "8px",
              cursor: "pointer",
              bgcolor: value === key ? "#1a73e8" : "#ffffff",
              transition: "all 0.15s ease",
              "&:hover": {
                borderColor: "#1a73e8",
                bgcolor: value === key ? "#1a73e8" : "#e8f0fe",
              },
            }}
          >
            <Icon sx={{ fontSize: 24, color: value === key ? "#ffffff" : "#5f6368" }} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default IconSelector;
export { AVAILABLE_ICONS };
